"use strict";

exports.__esModule = true;
exports.getTextColor = getTextColor;
exports.getProperty = getProperty;
exports.shade = shade;
var _theme = _interopRequireDefault(require("../theme"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
function getTextColor(props, primary) {
  if (primary === void 0) {
    primary = false;
  }
  if (props.primary) {
    return props.theme.primaryColor || _theme.default.primaryColor;
  }
  if (props.light) {
    return props.theme.textLight ? props.theme.textLight : _theme.default.textLight;
  }
  return props.theme.textDark ? props.theme.textDark : _theme.default.textDark;
}
function getProperty(props, property) {
  return props.theme[property] ? props.theme[property] : _theme.default[property];
}
function shade(color, percent) {
  var f = parseInt(color.slice(1), 16);
  var t = percent < 0 ? 0 : 255;
  var p = percent < 0 ? percent * -1 : percent;
  var R = f >> 16;
  var G = f >> 8 & 0x00ff;
  var B = f & 0x0000ff;
  return '#' + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}